import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
// HELPERS
import { decode } from 'Helpers/enc';
import { StackScreen } from '@life-line-lab/components-react';
import { VerificationScreen } from 'Components/shared/verification-screen';
import { fetchDriver } from 'Services/new-driver-management.services';

const CreateSuccess = () => {

  const history = useHistory();
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const riderID = decode(id);
  const messages = {
    successMsg: t("txt.riderRegistrationSuccess"),
    reviewMsg: t("txt.accountInReviewed"),
    emailMsg: t("txt.riderRegistrationEmailNotification"),
    appResultMsg: t("txt.onAppResult"),
    idMsg: t("txt.registrationID"),
  }

  const [driverData, setDriverData] = useState<any>({});

  useEffect(() => {
    document.body.classList.add('stack-screen--open');
    return () => document.body.classList.remove('stack-screen--open');
  }, []);

  useEffect(() => {
    handleFetchDriverDetails();
  }, [riderID]);

  const handleFetchDriverDetails = async () => {
    if (riderID) {
      const responseData = await fetchDriver(riderID);

      if (responseData && !responseData.error) {
        setDriverData(responseData);
      } else {
        handleCloseStackScreen();
      }
    }
  }

  const handleCloseStackScreen = () => {
    history.push('/driver-management/driver');
  }

  return (
    <StackScreen
      title={
        <div>
          <img
            alt={t('alt.logo')}
            src="/assets/images/banner_logo.png"
            height={30}
          />
        </div>
      }
      isOpen={true}
      renderHeader={<div></div>}
      onClose={handleCloseStackScreen}
    >
      <VerificationScreen fetchedPersonnel={driverData} messages={messages}/>
    </StackScreen>
  )
}

export default CreateSuccess